export const SCROLLABLE_CARDS_CSS = /* css */ `
  .lk-scrollable-cards {
    position: relative;
  }
  .lk-scroll-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    color: var(--wg-card-fg);
    transition: box-shadow 0.15s ease, opacity 0.15s ease;
  }
  .lk-scroll-arrow:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
  }
  .lk-scroll-arrow--left {
    left: 0;
  }
  .lk-scroll-arrow--right {
    right: 0;
  }
  @media (max-width: 768px) {
    .lk-scroll-arrow { display: none; }
  }
`;
